import { render, staticRenderFns } from "./TagsCategoriesAutocomplete.vue?vue&type=template&id=63bbe468"
import script from "./TagsCategoriesAutocomplete.vue?vue&type=script&lang=js"
export * from "./TagsCategoriesAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports